import { TRootState } from "Redux/Reducers";

export const getOrganizer = (id: string) => (state: TRootState) => state.organizer.entries[id];
